import React from 'react'
import PageBlocks from '../cms-page-blocks/list'

const AlumniBlockEditor = (props) => {
  return (
    <PageBlocks
      title='Alumni Session Sale Page Blocks'
      target='cms_fixed_page_blocks'
      cmsPageProp='page'
      cmsPageId='alumni'
      route={props.route}
    />
  )
}

export default AlumniBlockEditor
